import { render, staticRenderFns } from "./top-stories.vue?vue&type=template&id=677a13ba&"
import script from "./top-stories.vue?vue&type=script&lang=js&"
export * from "./top-stories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports